import React, { useState, useRef, useContext, useEffect } from 'react';
import {
  BsChevronDown,
  BsChevronLeft,
  BsChevronRight,
  BsListCheck,
  BsBriefcaseFill,
  BsClockHistory,
  BsBookmarkCheck,
  BsFillPatchQuestionFill,
  BsFiles,
  BsServer,
  BsFillHouseFill,
  BsPersonFillGear,
  BsWallet,
  BsPeopleFill,
} from 'react-icons/bs';
import { Link, useLocation } from 'react-router-dom';
import iCompass_icon from '../../images/iCompass_icon.png';
import iCompass_icon_crop from '../../images/iCompass_icon_crop.png';
import { jwtDecode } from 'jwt-decode';
import { TokenContext } from '../../App';

const SideBar = ({ setOpen, open }) => {
  const [encodedAccessToken] = useContext(TokenContext);
  const decodedToken = jwtDecode(encodedAccessToken);
  const Menus = [
    // { title: 'Home', src: '/', icon: <BsFillHouseFill /> },
    // { title: 'Admins', src: '/admin', icon: <BsPersonFillGear  /> },

    {
      title: 'Compliance Monitoring Program',
      src: '/compliance-monitoring',
      icon: <BsListCheck />,
      code: 'cmp',
      subMenus: [
        // {
        //   title: 'Dashboard',
        //   src: '/compliance-monitoring',
        //   cName: 'sub-nav',
        // },
        {
          title: 'Compliance Monitoring',
          src: '/compliance-monitoring/monitoring',
          cName: 'sub-nav',
        },
      ],
      isOpen: false,
    },

    {
      title: 'Fit and Proper Declaration',
      src: '/fit-and-proper',
      icon: <BsServer />,
      code: 'fit_proper',
      subMenus: [
        {
          title: 'Dashboard',
          src: '/fit-and-proper',
          cName: 'sub-nav',
        },
        {
          title: 'Reporting Status',
          src: '/fit-and-proper/reporting-status',
          cName: 'sub-nav',
        },
      ],
      isOpen: false,
    },

    {
      title: 'KYC/AML Portal',
      src: '/kyc-aml',
      icon: <BsBriefcaseFill />,
      code: 'kyc_aml',
      subMenus: [
        {
          title: 'Customer List',
          src: '/kyc-aml/customer-list',
          cName: 'sub-nav',
          icon: <BsPeopleFill />,
        },
      ],
      isOpen: true,
    },
  ];

  const currentLocation = useLocation();
  const pathname = currentLocation.pathname;

  const isPathUnderMenu = (path, menu) => {
    if (path === menu.src) return true;
    if (menu.subMenus?.length) {
      return menu.subMenus.some(
        sub => path === sub.src || path.startsWith(sub.src + '/')
      );
    }
    return false;
  };

  const isSubMenuActive = (subSrc) => {
    return pathname === subSrc || pathname.startsWith(subSrc + '/');
  };

  const [Menu, SetMenu] = useState(Menus);

  useEffect(() => {
    SetMenu(prev => {
      const anyMenuMatches = prev.some(m => isPathUnderMenu(pathname, m));
      return prev.map(menu => ({
        ...menu,
        isOpen: isPathUnderMenu(pathname, menu) || (menu.code === 'kyc_aml' && !anyMenuMatches),
      }));
    });
  }, [pathname]);

  const setSubMenuOpen = index => {
    SetMenu(prevMenus =>
      prevMenus.map((menu, i) => {
        if (i === index) {
          return { ...menu, isOpen: !menu.isOpen };
        } else {
          return { ...menu, isOpen: false }; // Close all other submenus
        }
      })
    );
  };

  return (
    <div className='relative'>
      {/*  Sidebar  */}
      <div className='h-screen flex items-end justify-start bg-white-200 fixed top-0 left-0 z-20'>
        <div
          className={`relative flex flex-col bg-white h-screen duration-300 transition-[width] ${open ? 'w-80 px-2' : 'w-16'}`}
        >
          <div className={`flex-shrink-0 justify-center mt-3 ${!open && 'overflow-hidden'}`}>
            {!open ? (
              <img src={iCompass_icon_crop} className='m-auto w-3/4 duration-200' alt='' />
            ) : (
              <img src={iCompass_icon} className='m-auto w-3/4 duration-200' alt='' />
            )}
          </div>
          {/* Menu list - scrollable */}
          <div className='flex-1 min-h-0 overflow-y-auto'>
          <ul className='pt-2'>
            {decodedToken?.role == 'admin' && (
              <Link to='/admin'>
                <li
                  className={`flex rounded-md p-2 cursor-pointer hover:text-green-400 text-black text-base items-center min-w-0 mt-2 ${open ? 'gap-x-4' : 'justify-center'} ${pathname === '/admin' || pathname.startsWith('/admin/') ? 'bg-green-50 text-green-600' : ''}`}
                  key='b22'
                >
                  <span className='flex-shrink-0 w-5 flex items-center justify-center'><BsPersonFillGear /></span>
                  {open && <span className='flex-1 truncate'>Admins</span>}
                </li>
              </Link>
            )}

            {decodedToken?.role == 'superAdmin' && (
              <Link to='/super'>
                <li
                  className={`flex rounded-md p-2 cursor-pointer hover:text-green-400 text-black text-base items-center min-w-0 mt-2 ${open ? 'gap-x-4' : 'justify-center'} ${pathname === '/super' ? 'bg-green-50 text-green-600' : ''}`}
                  key='c22'
                >
                  <span className='flex-shrink-0 w-5 flex items-center justify-center'><BsPersonFillGear /></span>
                  {open && <span className='flex-1 truncate'>Companies</span>}
                </li>
              </Link>
            )}
            {decodedToken?.role == 'superAdmin' && (
              <Link to='/super/kyc'>
                <li
                  className={`flex rounded-md p-2 cursor-pointer hover:text-green-400 text-black text-base items-center min-w-0 mt-2 ${open ? 'gap-x-4' : 'justify-center'} ${pathname === '/super/kyc' || pathname.startsWith('/super/kyc/') ? 'bg-green-50 text-green-600' : ''}`}
                  key='d22'
                >
                  <span className='flex-shrink-0 w-5 flex items-center justify-center'><BsWallet /></span>
                  {open && <span className='flex-1 truncate'>KYC Billing</span>}
                </li>
              </Link>
            )}

            {/* Subscriptions-unique Tabs */}
            <div>
              <div>
                {Menu.map(
                  (menuItem, index) =>
                    decodedToken?.subscriptions[menuItem?.code] && (
                      <div key={index}>
                        <li
                          onClick={() => setSubMenuOpen(index)}
                          key={`${index} aa`}
                          className={`flex rounded-md p-2 cursor-pointer hover:text-green-400 text-black text-base items-center min-w-0 ${menuItem.gap ? 'mt-9' : 'mt-2'} ${open ? 'gap-x-4' : 'justify-center'}`}
                        >
                          <span className='flex-shrink-0 w-5 flex items-center justify-center'>{menuItem.icon}</span>
                          {open && (
                            <>
                              <span key={`${index}bb`} className='flex-1 truncate'>
                                {menuItem.title}
                              </span>
                              {menuItem.subMenus && (
                                <BsChevronDown key={`${index}cc`} className={`flex-shrink-0 ${menuItem.isOpen && 'rotate-180'}`} />
                              )}
                            </>
                          )}
                        </li>
                        {menuItem.subMenus && menuItem.isOpen && open && (
                          <ul>
                            {menuItem.subMenus.map((subMenuItem, idx) => (
                              <Link
                                to={subMenuItem.src}
                                replace={pathname === subMenuItem.src}
                                key={`${index}-${idx}`}
                              >
                                <li
                                  key={`${idx} bb`}
                                  className={`flex px-5 cursor-pointer text-center py-1 items-center gap-x-2 ${isSubMenuActive(subMenuItem.src) ? 'text-green-600 bg-green-50 font-medium' : 'text-black-200'}`}
                                >
                                  <span className='flex-shrink-0 w-5 flex justify-center'>
                                    {subMenuItem.icon ?? <BsChevronDown className='-rotate-90' />}
                                  </span>
                                  {subMenuItem.title}
                                </li>
                              </Link>
                            ))}
                          </ul>
                        )}
                      </div>
                    )
                )}
              </div>
            </div>
          </ul>
          </div>

          {/* Bottom links - fixed at bottom of sidebar, moved up to leave room for toggle */}
          <div className='flex-shrink-0 text-base py-2 pt-2 pb-12 border-t border-gray-100'>
            <ul className='flex flex-col'>
              <li>
                <a
                  href='https://docs.google.com/forms/d/e/1FAIpQLSfxH4cA8iGlVRstA4SO_NE91t-bAS92UnQASdss2QrZ1CoU-w/viewform'
                  target='_blank'
                  rel='noopener noreferrer'
                  className={`flex rounded-md p-2 cursor-pointer hover:text-green-400 text-black text-base items-center mt-2 w-full min-w-0 ${open ? 'gap-x-4' : 'justify-center'}`}
                >
                  <span className='flex-shrink-0 w-5 flex items-center justify-center'><BsFillPatchQuestionFill /></span>
                  {open && <span className='flex-1 truncate'>Feedback</span>}
                </a>
              </li>
              <li>
                <Link to={'/change-log'} replace={pathname === '/change-log'} className={`flex rounded-md p-2 cursor-pointer hover:text-green-400 text-black text-base items-center mt-2 w-full min-w-0 ${open ? 'gap-x-4' : 'justify-center'} ${pathname === '/change-log' ? 'bg-green-50 text-green-600' : ''}`}>
                  <span className='flex-shrink-0 w-5 flex items-center justify-center'><BsClockHistory /></span>
                  {open && <span className='flex-1 truncate'>Change log</span>}
                </Link>
              </li>
              <li>
                <Link to={'/api-count'} replace={pathname === '/api-count'} className={`flex rounded-md p-2 cursor-pointer hover:text-green-400 text-black text-base items-center mt-2 w-full min-w-0 ${open ? 'gap-x-4' : 'justify-center'} ${pathname === '/api-count' ? 'bg-green-50 text-green-600' : ''}`}>
                  <span className='flex-shrink-0 w-5 flex items-center justify-center'><BsBookmarkCheck /></span>
                  {open && <span className='flex-1 truncate'>API Count</span>}
                </Link>
              </li>
            </ul>
          </div>

          {/* Collapse/Expand toggle - bottom right of sidebar */}
          <button
            type='button'
            onClick={() => setOpen(!open)}
            className='absolute right-0 bottom-0 z-10 w-8 h-10 flex items-center justify-center text-gray-400 transition-all duration-200 hover:bg-green-50 hover:text-green-600'
            aria-label={open ? 'Collapse sidebar' : 'Expand sidebar'}
          >
            {open ? <BsChevronLeft className='w-4 h-4' /> : <BsChevronRight className='w-4 h-4' />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
